<div class="container mt-3">
  <div class="row">
    <div class="col">

      <mat-card class="bg-body-tertiary bg-opacity-50 p-5">
        <mat-card-content>
          <mat-icon class="md-72 icon">wrong_location</mat-icon>
          <h1>Oops ...</h1>
          <h2>You were taken to a page that does not exist</h2>
        </mat-card-content>
      </mat-card>

    </div>
  </div>
</div>

